var _style, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path2, _rect7, _path3, _rect8, _path4, _rect9, _path5, _rect10, _path6, _rect11, _path7, _rect12, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _polygon, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1013.9 503",
    style: {
      enableBackground: "new 0 0 1013.9 503"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2F2E41;}\n\t.st1{fill:#F2F2F2;}\n\t.st2{fill:#3F3D56;}\n\t.st3{fill:#2F4858;}\n\t.st4{opacity:0.1;fill:#F2F2F2;enable-background:new    ;}\n\t.st5{fill:#FF6584;}\n\t.st6{opacity:0.1;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507,0C228.3,0,2.2,224.8,0,503h1013.9C1011.8,224.8,785.6,0,507,0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 480.8,
    cy: 52.5,
    r: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 323.8,
    cy: 217.5,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 618.8,
    cy: 311.5,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 97.8,
    cy: 286.5,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 877.8,
    cy: 215.5,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 235.8,
    cy: 236.5,
    r: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 563.8,
    cy: 196.5,
    r: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 629.8,
    cy: 52.5,
    r: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211.8,
    y: 288.5,
    className: "st1",
    width: 2,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270.8,
    y: 135.5,
    className: "st1",
    width: 2,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 414.8,
    y: 249.5,
    className: "st1",
    width: 2,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 796.8,
    y: 293.5,
    className: "st1",
    width: 2,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 677.8,
    y: 140.5,
    className: "st1",
    width: 2,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 225.1,
    y: 363.7,
    className: "st2",
    width: 3.5,
    height: 139
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M261.1,339.4c0.2,48.6-34,88.2-34,88.2s-34.6-39.2-34.8-87.9s34-88.2,34-88.2S260.9,290.8,261.1,339.4z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 322.5,
    className: "st2",
    width: 4.6,
    height: 180.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M227.3,303.4c0.3,63-44,114.3-44,114.3s-44.8-50.9-45.1-113.9s44-114.3,44-114.3S227,240.4,227.3,303.4z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 712.1,
    y: 363.7,
    className: "st3",
    width: 3.5,
    height: 139
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M748.1,381.4c0.2,48.6-34,88.2-34,88.2s-34.6-39.2-34.8-87.9c-0.2-48.6,34-88.2,34-88.2 S747.9,332.8,748.1,381.4z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 141.1,
    y: 363.7,
    className: "st2",
    width: 3.5,
    height: 139
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M177.1,339.4c0.2,48.6-34,88.2-34,88.2s-34.6-39.2-34.8-87.9s34-88.2,34-88.2S176.9,290.8,177.1,339.4z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 451.1,
    y: 363.7,
    className: "st2",
    width: 3.5,
    height: 139
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M487.1,339.4c0.2,48.6-34,88.2-34,88.2s-34.6-39.2-34.8-87.9s34-88.2,34-88.2S486.9,290.8,487.1,339.4z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 406.6,
    y: 322.5,
    className: "st2",
    width: 4.6,
    height: 180.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M453.3,303.4c0.3,63-44,114.3-44,114.3s-44.8-50.9-45.1-113.9s44-114.3,44-114.3S453,240.4,453.3,303.4z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 367.1,
    y: 363.7,
    className: "st2",
    width: 3.5,
    height: 139
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.1,339.4c0.2,48.6-34,88.2-34,88.2s-34.6-39.2-34.8-87.9s34-88.2,34-88.2S402.9,290.8,403.1,339.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M738.4,428.4l-58.8-54.1c-0.2,2.4-0.2,4.9-0.2,7.4c0.2,48.6,34.8,87.9,34.8,87.9 C724.2,457.1,732.3,443.2,738.4,428.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.6,490.3c2,7.4,8.9,12.1,8.9,12.1s3.6-7.5,1.6-14.9s-8.9-12.1-8.9-12.1S298.6,482.8,300.6,490.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.6,488.7c5.5,5.4,6.2,13.7,6.2,13.7s-8.3-0.5-13.8-5.8s-6.2-13.7-6.2-13.7S298.1,483.3,303.6,488.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M584.6,490.3c2,7.4,8.9,12.1,8.9,12.1s3.6-7.5,1.6-14.9c-2-7.4-8.9-12.1-8.9-12.1S582.6,482.8,584.6,490.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M587.6,488.7c5.5,5.4,6.2,13.7,6.2,13.7s-8.3-0.5-13.8-5.8c-5.5-5.4-6.2-13.7-6.2-13.7S582.1,483.3,587.6,488.7 z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.6,490.3c2,7.4,8.9,12.1,8.9,12.1s3.6-7.5,1.6-14.9s-8.9-12.1-8.9-12.1S74.6,482.8,76.6,490.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.6,488.7c5.5,5.4,6.2,13.7,6.2,13.7s-8.3-0.5-13.8-5.8s-6.2-13.7-6.2-13.7S74.1,483.3,79.6,488.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.3,220.7l96.5,145.7c2.2-8.8,3.2-17.9,3.2-27c-0.1-23.7-8.4-45.2-16.8-61l-4.5,1.1l4.2-1.6 c-5-9.4-10.9-18.2-17.7-26.4c0,0-2.5,2.9-6.1,8c-12.7-41.1-38.1-70-38.1-70C400.3,199.2,393.3,209.7,387.3,220.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M942.6,496.8c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9H919c1.6,3.2,0.3,7-2.9,8.6c0,1.6,1.3,2.9,2.9,2.9l0,0 h23.7c1.6,0,2.9-1.3,2.9-2.9S944.2,496.8,942.6,496.8L942.6,496.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M886.4,490.9c0.4,15.7-9.1,11.7-20.6,11.7s-21,2-21.1-11.7c0-6.7,9.4-8.2,20.9-8.2 C877.1,482.6,886.2,484.1,886.4,490.9z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M885.6,446.8c0.2,0,0.3-0.1,0.5-0.1c-0.5-0.1-1.1,0-1.6,0.2C884.9,446.9,885.3,446.9,885.6,446.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M896.7,494.5c0,0,0.1,0.1,0.1,0.1C896.8,494.6,896.7,494.6,896.7,494.5L896.7,494.5z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M941.3,486.2c0,10.6-4.7,7.7-10.6,7.7s-10.6,2.9-10.6-7.7s10.6-30.7,10.6-30.7S941.3,475.6,941.3,486.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M935.6,490.3c0,4.8-2.1,3.5-4.8,3.5s-4.8,1.3-4.8-3.5s4.8-14,4.8-14S935.6,485.5,935.6,490.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M944,457.9c0,0,2.2-2.3,2.1-4.5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M921.5,438.9c0,0-0.9-3-2.9-4.1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M899.5,397.9c0,0-0.9-3-2.9-4.1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M925.5,452.9c0,0-0.9-3-2.9-4.1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M922.5,403.9c0,0-0.9-3-2.9-4.1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M916.5,421.9c0,0-0.9-3-2.9-4.1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M942,488.9c0,0,2.2-2.3,2.1-4.5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M946,471.9c0,0,2.2-2.3,2.1-4.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "574.7,278 574.7,278 574.7,278 552.9,257.9 552.7,257.9 544,250 543.6,249.9 544,249.7 451.1,164.3  451.1,164.3 361.4,81.8 315.6,106 311.9,106.8 366.7,189.5 574.1,502.5 819,502.5 "
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 334.8,
    cy: 92.5,
    r: 27
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlone);
export default __webpack_public_path__ + "static/media/alone.85405240d8ba0582de7cc0b9808f45ce.svg";
export { ForwardRef as ReactComponent };